<template>
  <div>
    <el-card>
      <el-form
        label-position="top"
        size="small"
        :model="formParam"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <!-- 业务单号 -->
            <el-form-item label="" class="numberSearch">
              <template slot="label">
                <el-select v-model="formParam.orderType" style="width: 300px">
                  <!--运单号-->
                  <el-option :key="1" :label="$t('collectionCenter.waybillNumber')" value="waybillNumbers" />
                  <!--客户单号-->
                  <el-option :key="2" :label="$t('collectionCenter.customerNum')" value="customerNumbers" />
                  <!--子包号-->
                  <el-option :key="3" :label="$t('orderCenterCont.SubpackageNumber')" value="subPackageNos" />
                </el-select>
              </template>
              <el-input
                v-model="formParam.carNumber"
                :placeholder="$t('collectionCenter.max2000Line')"
                type="textarea"
                :rows="4"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div>
              <!--查询-->
              <el-button
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="search"
              >{{ $t('basicData.Search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh"
                size="mini"
                @click="onReset"
              >{{ $t('basicData.reset') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height - 10"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--运单号-->
        <el-table-column prop="waybillNumber" :label="$t('collectionCenter.waybillNumber')" />
        <!--客户单号-->
        <el-table-column prop="customerNumber" :label="$t('collectionCenter.customerNum')" />
        <!--子包号-->
        <el-table-column prop="subPackageNo" :label="$t('orderCenterCont.SubpackageNumber')" />
        <!--装载单号-->
        <el-table-column prop="shippingNo" :label="$t('mdfeTranslate.LoadNumber')" />
        <!--发票信息-->
        <el-table-column prop="invoiceJson" :label="$t('newOrder.InvoiceInformation')">
          <template v-slot="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.invoiceJson }}
              </pre>
              <div class="paramsStyle">{{ scope.row.invoiceJson }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--更新时间-->
        <el-table-column prop="updateTime" :label="$t('GlobalSetObj.UpdateTime')" />
        <!--更新人-->
        <el-table-column prop="updateUser" :label="$t('GlobalSetObj.Updater')" />
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight';
import { getNfseDataCheckPage } from '@/api/invoiceCenter';
export default {
  name: 'ExpressDelivery',
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {}
      },
      formParam: {
        orderType: 'waybillNumbers',
        carNumber: ''
      },
      tableData: [],
      total: 0
    };
  },
  methods: {
    // 查询条件处理
    handleFormData() {
      const param = {};
      const val = this.formParam.carNumber.split('\n');
      // 过滤空项
      const numLen = val.filter(function(f) {
        return f && f.trim();
      });
      // 去除空格
      const carNumber = numLen.map(item => {
        return item.replace(/\s/g, '').trim();
      });
      const inputVal = [];
      carNumber.map(item => {
        if (inputVal.includes(item) === false) {
          inputVal.push(item);
        }
      });
      param[this.formParam.orderType] = inputVal;
      return param;
    },
    // 查询
    search() {
      this.queryForm.pageNumber = 1;
      this.searchTable();
    },
    // 获取列表数据
    searchTable() {
      const param = this.handleFormData();
      if (param[this.formParam.orderType].length > 2000) {
        this.$message.error(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (param[this.formParam.orderType].length === 0) {
        this.$message.error(this.$t('trajectory.PleaseEnterCriteria'));
        return;
      }
      this.queryForm.params = param;
      getNfseDataCheckPage(this.queryForm).then(res => {
        if (res.code === 200) {
          res.data.records.map(item => {
            if (item.invoiceJson) {
              item.invoiceJson = JSON.stringify(JSON.parse(item.invoiceJson), null, 2);
            }
          });
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 重置
    onReset() {
      this.formParam = {
        orderType: 'waybillNumbers',
        carNumber: ''
      };
      this.queryForm.params = {};
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.searchTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.searchTable();
    }
  }
};
</script>
<style scoped>
.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
